import React, { useEffect, useState } from 'react';
import { Typography, Container, Button, IconButton, CircularProgress, Grid, Paper, Toolbar } from '@material-ui/core'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage  } from 'react-intl'
import MaterialTable from 'material-table';
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { IdentityActions, AccountActions, NotificationActions } from '../../../store';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

const style = theme => ({
    root: {
        height: '100%'
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const accountsSelector = (state) => state.Accounts;
const IdentitySelector = (state) => state.Identity;

const specificAcquirer = ["00000000-0000-0000-0000-000000000001", "00000000-0000-0000-0000-000000000002", "00000000-0000-0000-0000-000000000003"];

const AccountList = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const accountActions = bindActionCreators(AccountActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { list, nowWainting } = useSelector(accountsSelector);
    const { token, permissions, userData } = useSelector(IdentitySelector);

    const { classes } = props;

    // 一覧のフィルタリング要素の復元用
    var accountName = props.accountName;    // アカウント名
    var role = props.role;                  // 区分
    var orgName = props.orgName;            // 所属名
    var status = props.status;              // ステータス

    const listDefinition = {
        columns: [
            {
                title: <FormattedMessage id="Account.Name" />,
                field: 'name',
                filtering: true,
                defaultFilter: props.accountName,
            },
            {
                title: <FormattedMessage id="Account.Role" />,
                field: 'role',
                lookup:
                    userData.role == 1 ? {
                        2: "沖縄IC",
                        3: "代表加盟店",
                        4: "加盟店",
                        5: "店舗",
                    } : userData.role == 2 ? {
                        3: "代表加盟店",
                        4: "加盟店",
                        5: "店舗",
                    } : userData.role == 3 ? {
                        4: "加盟店",
                        5: "店舗",
                    } : userData.role == 4 ? {
                        5: "店舗",
                    } : {
                        /*userData.role == 5はアカウント管理無し*/
                    },
                filtering: true,
                defaultFilter: props.role,
            },
            {
                title: <FormattedMessage id="Account.Org" />,
                field: 'org_name',
                filtering: true,
                defaultFilter: props.orgName,
            },
            {
                title: <FormattedMessage id="Account.Status" />,
                field: 'status',
                lookup: {
                    0: "無効",
                    1: "有効"
                },
                filtering: true,
                defaultFilter: props.status,
            },
        ]
    };

    /**
     *
     * フィルター変更時
     *
     * @param filter フィルターデータ配列
     */
    const onChangeFilter = (filter) => {
        accountName = '';
        role = '';
        orgName = '';
        status = '';

        // フィルタリング内容を退避
        if (filter.length > 0) {
            for (let i = 0; i < filter.length; i++) {
                if (filter[i].column.field == 'name') {
                    accountName = filter[i].value;
                } else if (filter[i].column.field == 'role') {
                    role = filter[i].value;
                } else if (filter[i].column.field == 'org_name') {
                    orgName = filter[i].value;
                } else if (filter[i].column.field == 'status') {
                    status = filter[i].value;
                }
            };
        }
    }

    /**
     *
     * 初期表示処理
     * （指定された加盟店IDに紐づくアカウント一覧を取得し表示）
     * 
     */
    useEffect(() => {

        if (props.refresh == null || props.refresh == true) {
            // storeにアカウントリストを要求
            accountActions.listAccounts(token, props.merchantId)
                .then(data => {
                })
                .catch(e => {
                    notificationActions.showError(e.message);
                });        }

    }, []);

    /**
     * 
     * 戻る押下時の処理
     * （システム管理者、沖縄IC、代表加盟店ユーザでログインしている場合のみ）
     * 
     */
    const onBackClick = () => {
        props.onCancel(accountName, role, orgName, status);
    }

    /**
     * 
     * 詳細ボタン押下時の処理
     * 
     * @param data 選択された行のデータ 
     */
    const onDetailClick = (data) => {
        // 選択された行と復元用に変更されたフィルタリング要素を返却
        props.onDetail(data, accountName, role, orgName, status);
    }

    /**
     * 
     * 新規ボタン押下時の処理
     * 
     */
    const onCreateClick = () => {
        // 復元用に変更されたフィルタリング要素を返却
        props.onCreate(accountName, role, orgName, status);
    }

    const placeholder = <FormattedMessage id="Table.Action" />;

    // 戻るボタン（システム管理者、沖縄IC、MC代表加盟店ユーザでログインしている場合のみ）
    var backButton = '';
    //if (userData != null && (userData.role == 1 || userData.role == 2 || (userData.role == 3 && userData.org_id == '00000000-0000-0000-0000-000000000001'))) {
    if (userData != null && (userData.role == 1 || userData.role == 2 || (userData.role == 3 && specificAcquirer.some( v => v == userData.org_id) == true))) {
        backButton =
            <div style={{ padding: 10 }}>
                <Grid container item xs={12} spacing={2} justify="center">
                    <Grid item xs={3} sm={6}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={() => onBackClick()}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                </Grid>
            </div>;
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Toolbar variant="regular">
                    <div>
                        <Typography component="h1" variant="inherit"><FormattedMessage id="Account.Title" /></Typography>
                    </div>
                </Toolbar>
            </Paper>

            <MaterialTable
                title={<Typography component="h2" variant="inherit">{props.merchantName}</Typography>}
                onFilterChange={(filter) => onChangeFilter(filter)}
                columns={listDefinition.columns}
                data={list}
                options={{
                    search: false,
                    filtering: true,
                    actionsColumnIndex: -1
                }}
                localization={{
                    body: {
                        emptyDataSourceMessage: <FormattedMessage id="Table.EmptyDataSourceMessage" />
                    },
                    header: {
                        actions: ''
                    },
                }}
                components={{
                    // 右端のアクションボタン列（新規追加ボタン、詳細画面遷移ボタン）
                    Action: actionProps => {
                        if (actionProps.action.tooltip !== "Add") {
                            return (
                                <IconButton aria-label="detail" onClick={() => onDetailClick(actionProps.data)}>
                                    <ArrowForwardIosIcon />
                                </IconButton>
                            )
                        } else {
                            if (permissions != null && permissions != undefined && permissions.fid5_8 != null && (permissions.fid5_8.value.value & 2) == 2) {
                                // アカウント管理の編集権限の有りの場合のみ追加ボタンを表示（fid5_8：アカウント管理）
                                return (
                                    <Button onClick={() => onCreateClick()} variant="contained" color="secondary" size="medium" startIcon={<AddCircleOutlineIcon />} >
                                        <FormattedMessage id="Account.Create" />
                                    </Button>
                                )
                            }
                            else {
                                return (
                                    <div></div>
                                )
                            }
                        }
                    }
                }}
                editable={{
                    onRowAdd: newData => { },
                    onRowUpdate: (newData, oldData) => { }
                }}
            />
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}

            {backButton}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(AccountList);
